import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/components/PropertySegment.scss";
type PropertySegmentParams = {
  title: string;
  textArray: string[];
  className?: string;
  suffix?: string;
};
const PropertySegment: FC<PropertySegmentParams> = ({
  title,
  textArray,
  className = "",
  suffix,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`property-segment ${className}`}>
      <div className="property-label">{title}</div>
      <div className="property-data">
        {textArray.map((text, i) => (
          <span key={i}>
            {i > 0 && text ? ` / ${text}` : text}
          </span>
        ))}
        {suffix && textArray[0] && textArray[0] !== "N/A" && (
          <span className="property-unit"> {suffix}</span>
        )}
      </div>
    </div>
  );
};

export default PropertySegment;
